import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
import home from "./home/storeHome";
import NoticiasModules from "./noticias/storeNoticias";
import LoginModule from "./login/storeLogin";
import MenuModule from "./menu/storeMenu";
import VistosModule from "./menu/stroteVistos";
import GaleriaModule from "./galeria/storeGaleria";
import VideoModule from "./video/storeVideo";
import ReconoceModule from "./reconoce/storeReconoce";
import CulturaModule from "./cultura/storeCultura";
import OrganigramaModule from "./organigrama/storeOrganigrama";
import SeguridadModule from "./seguridad/storeSeguridad";
import BibliotecaModule from "./biblioteca/storeBiblioteca";
import CumpleanosModule from "./cumpleanos/storeCumpleanos";
import TransporteModule from "./transporte/storeTransporte";
import EncuestaModule from "./encuesta/storeEncuesta";
import FolovidModule from "./folovid/storeFolovid";
import ProfileModule from "./profile/storeProfile";
import BeneficioModule from "./beneficio/storeBeneficio";
import ChatModule from "./chat/storeChat";
import NotificacionModule from "./notificacion/storeNotificacion";
import LikesModule from "./likes/storeLikes";

export default new Vuex.Store({
    state: {},
    mutation: {},
    actions: {},
    modules: {
        LoginModule,
        home,
        NoticiasModules,
        MenuModule,
        VistosModule,
        GaleriaModule,
        VideoModule,
        ReconoceModule,
        CulturaModule,
        OrganigramaModule,
        SeguridadModule,
        BibliotecaModule,
        CumpleanosModule,
        TransporteModule,
        EncuestaModule,
        FolovidModule,
        ProfileModule,
        BeneficioModule,
        ChatModule,
        NotificacionModule,
        LikesModule
    }
})